var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerfectLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 26,
    viewBox: "0 0 137 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67781 15.6382H2.75034V25.676H-6.10352e-05V0.216064H7.53654C13.2866 0.216064 14.3918 4.79452 14.3918 6.97157V8.83287C14.3918 11.0681 13.2783 15.6382 7.67781 15.6382ZM11.6746 7.03805C11.6746 3.43179 8.95744 2.92492 7.46176 2.92492H2.74204V12.9294H7.52822C9.02391 12.9294 11.6746 12.3893 11.6746 8.78302V7.03805Z",
    fill: "#DC3D72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2831 25.676V0.216064H34.0351V2.93322H23.0003V10.8604H33.2124V13.5775H23.0003V23.0086H34.0351V25.6843H20.2831V25.676Z",
    fill: "#DC3D72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7478 25.676L47.7456 14.9236H43.5659V25.676H40.8156V0.216064H48.3521C54.1022 0.216064 55.2489 4.75298 55.2489 6.93003V8.1432C55.2489 10.0377 54.393 13.5692 50.6455 14.6744L55.8638 25.676H52.7478ZM52.4985 7.03805C52.4985 3.43179 49.7813 2.92492 48.2857 2.92492H43.5659V12.248H48.3521C49.8561 12.248 52.4985 11.6747 52.4985 8.10165V7.03805Z",
    fill: "#DC3D72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4277 2.92492V10.8936H75.6399V13.6108H65.4277V25.6843H62.7106V0.216064H76.4626V2.93322H65.4277V2.92492Z",
    fill: "#DC3D72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1713 25.676V0.216064H95.9233V2.93322H84.8884V10.8604H95.1006V13.5775H84.8884V23.0086H95.9233V25.6843H82.1713V25.676Z",
    fill: "#DC3D72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.534 26C103.925 26 102.354 21.3966 102.354 19.1448V6.71397C102.354 4.53691 103.817 0 109.567 0C115.143 0 116.746 4.53691 116.746 6.75551H113.996C113.996 3.21572 110.996 2.68392 109.567 2.68392C108.105 2.68392 105.072 3.22403 105.072 6.78875V19.1448C105.072 22.751 108.105 23.2911 109.567 23.2911C110.996 23.2911 113.996 22.751 113.996 19.1863H116.746C116.746 21.4299 115.242 26 109.534 26Z",
    fill: "#DC3D72"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M129.958 2.96646V25.6843H127.208V2.96646H120.993V0.216064H136.166V2.96646H129.958Z",
    fill: "#DC3D72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectLogo);
export default __webpack_public_path__ + "static/media/PERFECT_logo.1504c35493c6c1673743ce6913936342.svg";
export { ForwardRef as ReactComponent };